// src/constants/snsTypes.ts

import { IoLogoFacebook, IoLogoTwitter } from "react-icons/io";
// Import the actual icon for ArtStation instead of using IoLogoFacebook as a placeholder
import { FaArtstation } from "react-icons/fa";
import DiscordIcon from "../../components/DiscordIcon";

export interface SnsType {
    id: number;
    name: string;
    icon: React.ReactNode;
}

export const snsTypes: SnsType[] = [
    { id: 1, name: 'ArtStation', icon: <FaArtstation /> },
    { id: 2, name: 'Discord', icon: <DiscordIcon /> },
    { id: 3, name: 'Twitter', icon: <IoLogoTwitter /> },
    { id: 4, name: 'Facebook', icon: <IoLogoFacebook /> }
];